import { enableProdMode } from '@angular/core';
import { Acl } from '@df/core/service/acl';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

if (Acl.isProdMode()) {
    enableProdMode();
}

// document.addEventListener('DOMContentLoaded', () => {
platformBrowserDynamic()
    .bootstrapModule(AppModule, { ngZone: 'noop' })
    .catch(err => console.error(err));
// });
